module.exports = __webpack_public_path__ + "f8894a7729804c6f2f709b96e5fe8bd6.MP3";